import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useHasPolarisInPath: (args_0: void) => boolean = createRouterSelector(
	({ location }): boolean => {
		return location.pathname.includes('/jira/polaris');
	},
);
